module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.41940db3.ttf";